import { useState } from "react";
import INTOUCH_API from "../../services/Api";
import { useNavigate } from "react-router-dom";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import Game from "../../store/Game";
import ROUTES from "../../utils/routes.js";

export default function useController() {
  const [creatingCard, setCreatingCard] = useState(null);
  const { getUserData } = useCurrentUserData();
  const navigate = useNavigate();

  const createInsightForm = (card) => {
    const game = Game.game;
    const data = {
      gameId: game.id,
      questionId: card.id,
    };
    setCreatingCard(card);
    INTOUCH_API.requestManager(
      "createInsightForm",
      data,
      (response) => {
        navigate(ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(response.data.id), {
          state: { formId: response.data.id, gameId: game.id },
        });
      },
      (err) => {
        if (err.status === 400) {
          INTOUCH_API.requestManager(
            "getInsightFormPairByQuestionId",
            { payload: { questionId: card.id, gameId: game.id } },
            (response) => {
              const currentUser = getUserData();
              const foundInsightForm = response.data.find(
                (form) => form.userId === currentUser.id
              );
              // 400 мог прийти как gameNotFound (игра без партнёра), а не только
              // «анкета уже создана» — тогда пары нет и .id читать нельзя
              if (!foundInsightForm) return;
              navigate(
                ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(foundInsightForm.id),
                {
                  state: { formId: foundInsightForm.id, gameId: game.id },
                }
              );
            }
          );
        }
      },
      // сбрасываем спиннер на ЛЮБОМ исходе — иначе ранний return (соло-игра без
      // пары) оставлял creatingCard навсегда, блокируя все карточки
      () => setCreatingCard(null)
    );
  };

  return {
    creatingCard,
    createInsightForm,
  };
}
